import styled from 'styled-components';
import { color } from 'styles/Theme';

export const containerAccordionInside = styled.div`
	width: 100%;
	padding-top: 0.4rem;
	gap: 0.5rem;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
`;

export const containerAccordionText = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
	padding-top: 1rem;
	gap: 0.2rem;

	h4 {
		font-weight: 700;
		color: ${color.interface.darkGray};
		text-transform: uppercase;
		font-size: 13px;
	}

	p {
		width: 100%;
		font-weight: 200;
		color: ${color.interface.darkGray};
		text-align: left;
		font-size: 11px;
	}
`;

export const boxToggle = styled.div`
	width: 100%;
	align-self: flex-start;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	p {
		opacity: 0.7;
		font-size: 0.9rem;
	}
`;

export const notice = styled.p`
	padding: 10px 0px 10px 0px;
	font-size: 13px;
	color: ${color.interface.red};
`;
